"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OffersListingDataDtoListingStatusEnum = void 0;
exports.instanceOfOffersListingDataDto = instanceOfOffersListingDataDto;
exports.OffersListingDataDtoFromJSON = OffersListingDataDtoFromJSON;
exports.OffersListingDataDtoFromJSONTyped = OffersListingDataDtoFromJSONTyped;
exports.OffersListingDataDtoToJSON = OffersListingDataDtoToJSON;
exports.OffersListingDataDtoToJSONTyped = OffersListingDataDtoToJSONTyped;
/**
 * @export
 */
exports.OffersListingDataDtoListingStatusEnum = {
    Draft: 'draft',
    Active: 'active',
    UnderOffer: 'under_offer',
    OffTheMarket: 'off_the_market',
    PassedIn: 'passed_in',
    Disabled: 'disabled',
    Deleted: 'deleted',
    Sold: 'sold'
};
/**
 * Check if a given object implements the OffersListingDataDto interface.
 */
function instanceOfOffersListingDataDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('listingStatus' in value) || value['listingStatus'] === undefined)
        return false;
    return true;
}
function OffersListingDataDtoFromJSON(json) {
    return OffersListingDataDtoFromJSONTyped(json, false);
}
function OffersListingDataDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'listingImage': json['listingImage'] == null ? undefined : json['listingImage'],
        'listingStatus': json['listingStatus'],
        'slug': json['slug'] == null ? undefined : json['slug'],
    };
}
function OffersListingDataDtoToJSON(json) {
    return OffersListingDataDtoToJSONTyped(json, false);
}
function OffersListingDataDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'listingImage': value['listingImage'],
        'listingStatus': value['listingStatus'],
        'slug': value['slug'],
    };
}
